import { action, computed, makeObservable, observable } from 'mobx';

import { equalsDeep } from 'src/shared/utils/equals-deep';
import type { PadPreparation } from 'src/store/well-pad-preparation/entities';
import type { TPadReadiness, TPreparationStatus } from 'src/store/well-pad-preparation/types';

export const defaultFilterData: TFilterData = {
  padReadiness: {
    ready: true,
    notReady: true,
    inProcess: true,
  },
  padDocumentationReadiness: {
    ready: true,
    notReady: true,
    inProcess: true,
  },
  routeReadiness: {
    ready: true,
    notReady: true,
    inProcess: true,
  },
  routeDocumentationReadiness: {
    ready: true,
    notReady: true,
    inProcess: true,
  },
  electricityReadiness: {
    ready: true,
    notReady: true,
    inProcess: true,
  },
};

export type TFilterData = {
  [Key in keyof TPadReadiness]: Record<TPreparationStatus, boolean>;
};

// Подвязать к стору настроек, чтобы выбранные фильтры сохранялись
export class WellPadPreparationFilterStore {
  @observable filterData: TFilterData = defaultFilterData;

  constructor() {
    makeObservable(this);
  }

  @computed
  get isFilterActive(): boolean {
    return !equalsDeep(this.filterData, defaultFilterData);
  }

  private getFilterFn(filterData: TFilterData): (pad: PadPreparation) => boolean {
    const filterFns = (() => {
      const fns: ((pad: PadPreparation) => boolean)[] = [];

      for (const _key in filterData) {
        const key = _key as keyof TFilterData;

        const readinesObject = filterData[key];

        for (const _statusKey in readinesObject) {
          const statusKey = _statusKey as TPreparationStatus;

          if (readinesObject[statusKey]) {
            continue;
          }

          fns.push((pad) => pad.padReadiness[key] === statusKey);
        }
      }

      return fns;
    })();

    return (pad: PadPreparation): boolean => {
      return !filterFns.some((fn) => fn(pad));
    };
  }

  @action.bound
  updateFilterData(data: TFilterData) {
    this.filterData = data;
  }

  @computed
  get filterFn() {
    return this.getFilterFn(this.filterData);
  }
}
